/**
 * Úvodní video – přepíná zdroj podle šířky obrazovky (desktop / mobil).
 *
 * Reaguje i na RESIZE přes hranici breakpointu (820px), takže se video
 * nezasekne na staré variantě. Přepne se jen při skutečném překročení
 * hranice (matchMedia 'change'), ne při každém pixelu resize.
 * Autoplay: muted video smí hrát bez interakce uživatele.
 */
function initHomepageVideo() {
    const video = document.getElementById('hp-video');
    if (!video) return;

    const sources = {
        desktop: '/www/assets/img/homepage-desktop-VIDEO.mp4',
        mobile: '/www/assets/img/homepage-mobile-VIDEO-2.mp4',
    };

    // Breakpoint "s" z configu (820px) = hranice mobil / desktop
    const mq = window.matchMedia('(max-width: 820px)');

    const play = () => {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => {
                // Prohlížeč autoplay zablokoval – spustíme při první interakci
                const start = () => {
                    video.play();
                    document.removeEventListener('touchstart', start);
                    document.removeEventListener('click', start);
                };
                document.addEventListener('touchstart', start, { once: true });
                document.addEventListener('click', start, { once: true });
            });
        }
    };

    const applySource = () => {
        const wanted = mq.matches ? sources.mobile : sources.desktop;
        if (video.dataset.src === wanted) return; // správný zdroj už je nasazený

        video.dataset.src = wanted;
        video.innerHTML = '';
        const source = document.createElement('source');
        source.src = wanted;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
        play();
    };

    applySource();

    // Překročení hranice mobil/desktop při resize → vyměnit zdroj
    mq.addEventListener('change', applySource);
}

document.addEventListener('DOMContentLoaded', initHomepageVideo);
